import {APP_INITIALIZER, NgModule, SecurityContext} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {MaterialModule} from './material/material.module';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';

import {DataManagementModule} from './modules/data-management/data-management.module';
import {SalesDnaModule} from './modules/sales-dna/sales-dna.module';
import {RouterModule} from '@angular/router';
import {SettingsModule} from './modules/settings/settings.module';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FooterComponent} from './components/footer/footer.component';
import {NotFoundPageComponent} from './components/not-found-page/not-found-page.component';
import {HomeModuleModule} from './modules/home-module/home-module.module';
import {TextPrettyPipe} from './pipes/text-pretty.pipe';
import {FormBuilderComponent} from './components/form-buider/form-buider.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {FormBuilderSecondaryComponent} from './components/form-builder-secondary/form-builder-secondary.component';
import {ShowDialogsComponent} from './components/show-dialogs/show-dialogs.component';
import {
  DeploySolutionFormComponent
} from './modules/sales-dna/components/deploy-solution-form/deploy-solution-form.component';
import {MarkdownModule} from 'ngx-markdown';
import {StaticSourceDirective} from './directives/static-src.directive';
import {SolutionsManagerModule} from './modules/solutions-manager/solutions-manager.module';
import {AccountModule} from './modules/account/account.module';
import {CustomerHomeModule} from './modules/customer-home/customer-home.module';
import {DataConnectionModule} from './modules/data-connection/data-connection.module';
import {SalesRepModule} from './modules/sales-rep/sales-rep.module';
import {HttpHeaderInterceptorService} from './services/http-header-interceptor.service';
import {AuthInterceptor} from "./services/auth-interceptor";
import {UserStateService} from './services/user-state.service';
import {appInitializerFactory} from './initializers/app.initializer';
import {LoadingScreenComponent} from './components/loading-screen/loading-screen.component';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    NotFoundPageComponent,
    DeploySolutionFormComponent,
    LoadingScreenComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    MaterialModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,

    AppRoutingModule,
    AccountModule,
    CustomerHomeModule,
    DataConnectionModule,
    DataManagementModule,
    HomeModuleModule,
    SalesDnaModule,
    SalesRepModule,
    SettingsModule,
    SolutionsManagerModule,

    TextPrettyPipe,
    FormBuilderComponent,
    FormBuilderSecondaryComponent,
    FormsModule,
    ShowDialogsComponent,
    MarkdownModule.forRoot({
      loader: HttpClient,
      sanitize: SecurityContext.NONE,
    }),
    MarkdownModule.forChild(),
    StaticSourceDirective,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeaderInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [UserStateService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
